<div class="d-flex">
  <div>
    <button
      [ngClass]="
        selectedComponent === 'daily-planning-overview'
          ? 'selected-button'
          : 'non-selected-button'
      "
      (click)="setSelectedComponent('daily-planning-overview')"
      type="button"
      mat-button
    >
      Weekplanning
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedComponent === 'admin-planning-map'
          ? 'selected-button'
          : 'non-selected-button'
      "
      (click)="setSelectedComponent('admin-planning-map')"
      type="button"
      mat-button
    >
      Kaart
    </button>
  </div>
  <div
    *ngIf="selectedComponent === 'admin-planning-map'"
    class="center-checkbox small-upper-space"
  >
    <mat-checkbox
      [(ngModel)]="hidePlannedProjects"
      (ngModelChange)="hidePlannedProjectsChange()"
    >
      Verberg ingeplande
    </mat-checkbox>
  </div>
  <div
    *ngIf="selectedComponent === 'admin-planning-map'"
    class="end-flex align-with-view-selector-buttons"
  >
    <product-type-criterium-selector></product-type-criterium-selector>
  </div>
</div>

<daily-planning-overview
  *ngIf="selectedComponent === 'daily-planning-overview'"
></daily-planning-overview>

<admin-planning-map
  *ngIf="selectedComponent === 'admin-planning-map'"
  [hidePlannedProjects]="hidePlannedProjects"
></admin-planning-map>
